import type { AudioImageSyncFormat } from '@/formats/UnitParser';
import type { ImageDimensions } from '@/formats/inputSourcesParsers/SourceParser';
import type { Pixel } from '@/data';
import { getAudioData, linearPath } from 'waveform-path';
import type IRenderService from './IRenderService';

export class WaveFormService implements IRenderService<AudioImageSyncFormat> {
  positions: AudioImageSyncFormat;

  // TODO add the
  // synchronization: ???;

  dimensions: ImageDimensions;

  svgImage: string;

  private musicFileURL: string;

  private HEIGHT = 100;

  constructor(
    musicFileURL: string,
  ) {
    this.musicFileURL = musicFileURL;

    this.positions = {
      'date-x': [{ date: 0, x: 0 }, { date: 3000, x: 30000 }],
      staffs: [{
        bottom: 0,
        top: 10,
      }],
    } as AudioImageSyncFormat;
    this.dimensions = { width: 0 as Pixel, height: 0 as Pixel };
    this.svgImage = '';
  }

  async loadAndRender(): Promise<void> {
    const audioData = await getAudioData(this.musicFileURL);
    const nbSeconds = Math.round(audioData.duration);

    this.svgImage = linearPath(audioData, {
      samples: nbSeconds * 10,
      type: 'mirror',
      top: 0,
      height: this.HEIGHT,
      width: nbSeconds * 10,
    });

    this.dimensions = { width: nbSeconds * 10 as Pixel, height: this.HEIGHT as Pixel };

    this.positions = {
      'date-x': [{ date: 0, x: 0 }, { date: nbSeconds, x: nbSeconds * 100 }],
      staffs: [{
        bottom: 0,
        top: 100,
      }],
    } as AudioImageSyncFormat;
  }
}
